import React from "react";
import { FaUserGraduate, FaChalkboardTeacher, FaUserTie, FaUserCog, FaHandsHelping, FaUsers } from "react-icons/fa";
import { motion } from "framer-motion";

const personalData = [
  { rol: "Estudiantes", cantidad: 2008, icon: <FaUserGraduate size={30} className="text-blue-600" /> },
  { rol: "Directivos", cantidad: 5, icon: <FaUserTie size={30} className="text-purple-600" /> },
  {rol:"Personal Jerarquico", cantidad: 12, icon: <FaUserTie size={30} className="text-purple-600" /> },
  { rol: "Docentes", cantidad: 95, icon: <FaChalkboardTeacher size={30} className="text-green-600" /> },
  { rol: "Auxiliares de Educación", cantidad: 7, icon: <FaHandsHelping size={30} className="text-yellow-500" /> },
  { rol: "Administrativos", cantidad: 9, icon: <FaUserCog size={30} className="text-red-500" /> },
  { rol: "Personal de Servicio", cantidad: 7, icon: <FaUsers size={30} className="text-pink-500" /> },
];

const Personal: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-20">
      <h1 className="text-3xl font-bold text-center mb-12 text-blue-800">Nuestro Personal</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {personalData.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="group bg-white shadow-md rounded-2xl p-6 border hover:shadow-xl hover:scale-[1.02] transition-all duration-300"
          >
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-xl font-semibold text-gray-800">{item.rol}</h2>
                <p className={`text-3xl font-bold ${item.rol === "Estudiantes" ? "text-blue-700" : "text-gray-700"}`}>
                  {item.cantidad}
                </p>
              </div>
                <div className="transition-transform duration-300 group-hover:scale-125">
                {item.icon}
                </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Personal;
